module.exports = __webpack_public_path__ + "static/media/lamp.d13c4f69.jpg";